var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336.834,
    height: 352.41,
    viewBox: "0 0 336.834 352.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    d: "M0,0H163.334a0,0,0,0,1,0,0V251.713a16,16,0,0,1-16,16H16a16,16,0,0,1-16-16V0A0,0,0,0,1,0,0Z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration_doc",
    transform: "translate(905 -1993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_05",
    "data-name": 5,
    transform: "translate(-904 1994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Doctor",
    transform: "translate(0 24.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M185.049,606.384v-72.8c-.876,3.128-2.613,5.144-5.834,4.24-6.283-1.758-3.216-10.376-.131-16.445a102.944,102.944,0,0,0-19.119-5.314,103,103,0,0,0-8.217,18.061c6.629,1.534,15.2,4.722,12.512,10.671-2.564,5.67-9.554.92-14.681-3.72-.761,2.767-1.43,5.686-1.961,8.71h0a97.739,97.739,0,0,0-22.154-2.821,98.721,98.721,0,0,0,7.6,36.594h-.005a9.318,9.318,0,0,0-.959,13.635l16.588,17.695-20.242-6.294a8.118,8.118,0,1,0-2.41,15.87h77.094A18.076,18.076,0,0,1,185.049,606.384Z",
    transform: "translate(-117.904 -298.731)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M626.66,607.405A98.831,98.831,0,0,0,605.443,592.9l-.005-.006a99.561,99.561,0,0,0,2.7-16.467c-7.116,2.9-16.221,5.193-16.741-1.7-.548-7.231,9.614-7.3,17.119-6.388a114.476,114.476,0,0,0-1.72-21.978,114.47,114.47,0,0,0-21.978-1.72c.915,7.505.844,17.667-6.388,17.119-6.892-.526-4.6-9.625-1.7-16.741a99.074,99.074,0,0,0-17.212,2.887l.033,4.35c5.018,4.854,9.088,10.737,4.185,14.166a4.4,4.4,0,0,1-4.185.751l-.027.865.033,48.717a5.73,5.73,0,0,1,.827.208c5.944,1.9,4.476,10.321,2.191,17.054,5.6,1.3,12.014.526,19.009-4.152h0C607.185,625.965,626.66,607.405,626.66,607.405Z",
    transform: "translate(-317.589 -311.651)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M613.1,650.79a64.2,64.2,0,0,1-10.513,17.771c-3.161-6.618-10.973-20.79-17.426-14.654-6.535,6.212,8.08,14.517,14.594,17.771",
    transform: "translate(-328.44 -359.654)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M625.836,632.457c-5.149-6.223-13.2-13.969-17.459-7.883-2.936,4.2,1.046,7.6,6.355,10.085",
    transform: "translate(-339.231 -346.799)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M634.812,587.586c-7.505-.915-17.667-.844-17.119,6.388.526,6.891,9.625,4.6,16.741,1.7a95.843,95.843,0,0,1-3.95,20.883",
    transform: "translate(-343.884 -330.89)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M588.608,545.34c-2.9,7.116-5.193,16.221,1.7,16.741,3.933.3,5.747-2.569,6.437-6.453",
    transform: "translate(-329.464 -311.971)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    y1: 20.192,
    x2: 20.198,
    transform: "translate(241.959 261.768)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M186.067,515.71a103,103,0,0,0-8.217,18.061c6.629,1.534,15.2,4.722,12.512,10.671-2.564,5.67-9.554.92-14.681-3.72",
    transform: "translate(-144.022 -298.573)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x1: 10.551,
    y1: 22.625,
    transform: "translate(56.595 248.346)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M132.054,579.847a76.376,76.376,0,0,1-.405-7.719s35.005-.592,56.239,20.636q1.8,1.8,3.4,3.725",
    transform: "translate(-124.111 -324.083)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M180.033,668.018a65.323,65.323,0,0,1-23.441-14.572c-7.6-7.6-12.4-16.955-15.432-25.846",
    transform: "translate(-128.412 -349.167)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x2: 18.089,
    y2: 18.089,
    transform: "translate(49.057 289.564)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x2: 16.528,
    y2: 16.528,
    transform: "translate(24.931 265.433)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M397.176,444.884H258.513A18.084,18.084,0,0,1,240.43,426.8V137.423a18.084,18.084,0,0,1,18.083-18.083H397.171a18.084,18.084,0,0,1,18.083,18.083V426.8A18.077,18.077,0,0,1,397.176,444.884Z",
    transform: "translate(-173.301 -119.34)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M402.15,453.78H263.487a12.054,12.054,0,0,1-12.057-12.057V164.407a12.054,12.054,0,0,1,12.057-12.057H402.145A12.054,12.054,0,0,1,414.2,164.407V441.722A12.05,12.05,0,0,1,402.15,453.78Z",
    transform: "translate(-178.275 -134.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x2: 68.455,
    transform: "translate(125.367)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M268.911,514.082h-10.4A18.084,18.084,0,0,1,240.43,496V272.37",
    transform: "translate(-173.301 -188.538)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M465.8,483.58V591.5a18.084,18.084,0,0,1-18.083,18.083H352.21",
    transform: "translate(-223.846 -284.044)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    y2: 92.247,
    transform: "translate(241.959 53.034)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    y1: 62.862,
    transform: "translate(73.155 83.832)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    y1: 96.673,
    transform: "translate(73.155 210.783)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M379.257,692.637H263.487A12.054,12.054,0,0,1,251.43,680.58",
    transform: "translate(-178.275 -373.124)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    y2: 107.92,
    transform: "translate(235.933 199.536)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    y2: 44.088,
    transform: "translate(235.933 101.192)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x2: 18.089,
    transform: "translate(145.5 9.192)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 2.898,
    cy: 2.898,
    r: 2.898,
    transform: "translate(132.96 6.294)",
    fill: "#3c475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M158.286,670.27,141.7,652.575a9.318,9.318,0,0,1,.959-13.635",
    transform: "translate(-127.516 -354.295)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M157.464,706.9H126.009a8.118,8.118,0,0,1-8.119-8.119h0",
    transform: "translate(-117.89 -381.354)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M631.42,640.79a93.206,93.206,0,0,1,13.46,10.1s-19.48,18.56-45.08,22.471",
    transform: "translate(-335.803 -355.132)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M251.43,169.869v-5.462a12.054,12.054,0,0,1,12.057-12.057H363.31",
    transform: "translate(-178.275 -134.267)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x1: 9.127,
    transform: "translate(106.868)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    x1: 7.549,
    transform: "translate(112.795 325.545)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shield",
    transform: "translate(38.411 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M507.872,160.762a74.824,74.824,0,0,0,36.172-64.478q0-3.772-.361-7.445a80.57,80.57,0,0,1-35.811-14.89,80.57,80.57,0,0,1-35.811,14.89c-.236,2.449-.362,4.93-.362,7.445a74.824,74.824,0,0,0,36.172,64.478Z",
    transform: "translate(-471.7 -73.95)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M517.284,79.981a73.862,73.862,0,0,1-9.411-6.031,80.571,80.571,0,0,1-35.811,14.89c-.236,2.449-.362,4.93-.362,7.445a74.81,74.81,0,0,0,36.172,64.478h0a73.179,73.179,0,0,0,19.486-16.927",
    transform: "translate(-471.7 -73.95)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M519.21,152.684l-14.32-14.32,6.136-6.141,8.184,8.184,18.418-18.418,6.135,6.141Z",
    transform: "translate(-486.708 -95.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M545.961,133.2l-24.553,24.553L509.75,146.1",
    transform: "translate(-488.906 -100.742)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-831.708 2069.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03",
    "data-name": 3,
    transform: "translate(-8.585 5.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M250.9,204.53a23.716,23.716,0,0,1,5.455-32.013A38.2,38.2,0,0,1,271.372,119.5a23.711,23.711,0,0,1,23-29.472c.779,0,1.548.041,2.3.114a27.654,27.654,0,0,1,48.98,15.41,23.716,23.716,0,0,1,17.309,30.9,38.278,38.278,0,0,1,13.443,19.13l2.254,36.22-11.17,9.135Z",
    transform: "translate(-223.807 -80)",
    fill: "#3c475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M374.588,184.38l.014.023a13.531,13.531,0,0,0-4-3.206l.018,0-4.64-1.444.023,0a13.6,13.6,0,0,0-1.621-.1,13.357,13.357,0,0,0-6.926,1.926l-7.108,3.534a7.957,7.957,0,0,0-4.258,8.7L348.25,204.5l-1.617,12.6h0l-7.067-1.248-1.462,8.3c-10.742-6.325-26.239-8.8-26.239-8.8h0l-4.472-2.919-6.944-1.034-3.866-17.869h0c10.123-7.846,12.7-24.927,12.7-24.982a7.24,7.24,0,1,0-2.09-10.323h0c-27.75-2.664-34.435-22.008-34.435-22.008s-1.976,15.137-11.125,22.473a7.705,7.705,0,1,0-.1,11.339l.1-.091s1.967,17.213,13.028,24.376h0l-2.441,18-7.195,1.02-1.872,1.585h0s-30.956,9.485-40.237,20.565S187.5,299.917,199,315.668c4.3,5.888,11.562,7.841,20.223,7.354l-14.071,55.291,71.721,23.743L288.227,357.7l11.357,44.358L371.3,378.314l-17.951-70.528a28.626,28.626,0,0,0,8.065-15.984c.842-7.086,2.618-34.608,3.862-52.008h0l3.9.688,3.32-18.821-6.594-1.161h0l7.108-17.19h0a13.4,13.4,0,0,0,4.012-5.806h0Zm2.236,3.7Zm.961,5.032v-.032l0,.014Z",
    transform: "translate(-196.127 -110.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M323.12,387.585l17.96-6.535.865,2.377,7.063-7.759,5.528-1.9L346.03,350.39l-57.14,20.8,10.469,28.77,24.859-9.362Z",
    transform: "translate(-246.648 -227.262)",
    fill: "#882474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M398.788,485.844,388.218,456.8l-13.957,5.915,2.81,7.719-17.96,6.535-1.389-3.821c-6.352,3.652-14.713,8.2-23.752,12.386l7.682,21.107Z",
    transform: "translate(-271.2 -285.216)",
    fill: "#882474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M439.543,584.483l21.111,1.27L478.3,574.1l-2.468-9.226L437.07,575.257Z",
    transform: "translate(-327.351 -344.074)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M307.846,584.483l-21.116,1.27L269.08,574.1l2.473-9.226,38.766,10.387Z",
    transform: "translate(-235.859 -344.074)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 33.442,
    height: 19.112,
    transform: "translate(94.424 153.786) rotate(70.001)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 33.442,
    height: 19.112,
    transform: "translate(143.445 105.225) rotate(9.997)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M358.855,297.91V284.841c13.688-1.571,25.041-14.29,28.128-32.008a2.866,2.866,0,0,0-5.647-.984,39.05,39.05,0,0,1-9.331,19.841c-4.627,4.964-10.164,7.587-16.015,7.587s-11.389-2.623-16.015-7.587a39.05,39.05,0,0,1-9.331-19.841,2.866,2.866,0,0,0-5.647.984c3.087,17.718,14.44,30.437,28.128,32.008v15.15",
    transform: "translate(-266.29 -172.301)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M376.407,155.578a38.278,38.278,0,0,0-13.443-19.13,23.716,23.716,0,0,0-17.309-30.9,27.657,27.657,0,0,0-48.98-15.41c-.76-.073-1.525-.114-2.3-.114a23.711,23.711,0,0,0-23,29.472,38.2,38.2,0,0,0-15.018,53.014,23.716,23.716,0,0,0-5.455,32.013",
    transform: "translate(-223.807 -80)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M392.15,236.053c19.586,0,23.9-28.843,23.9-28.843",
    transform: "translate(-302.887 -149.282)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M339.99,210.27s2.477,21.671,17.491,26.5",
    transform: "translate(-274.479 -150.949)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M440.04,180.885a7.241,7.241,0,1,1,2.09,10.323",
    transform: "translate(-328.969 -133.276)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M324.383,194.424a7.709,7.709,0,1,1,.1-11.343",
    transform: "translate(-258.968 -135.007)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M385.56,158.228c-27.75-2.664-34.435-22.008-34.435-22.008S349.148,151.357,340,158.693",
    transform: "translate(-274.484 -110.619)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M385.043,196.13s-2.345,9.057-3.033,12.582,3.6,4.208,3.6,4.208",
    transform: "translate(-297.324 -143.248)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M400.441,240.8a8.653,8.653,0,0,1-6.471,4.349",
    transform: "translate(-303.878 -167.576)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 2.864,
    cy: 2.864,
    r: 2.864,
    transform: "translate(94.505 51.753)",
    fill: "#3c475d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 2.627,
    cy: 2.627,
    r: 2.627,
    transform: "translate(75.283 51.99)",
    fill: "#3c475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M445.21,191.93c.323-5.027,4.9-5.993,6.635-3.994",
    transform: "translate(-331.785 -138.256)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M329.605,194.716a4.264,4.264,0,0,0-7.345-3.543",
    transform: "translate(-264.823 -139.816)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x1: 3.866,
    y1: 17.869,
    transform: "translate(100.461 84.701)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x1: 2.441,
    y2: 18.001,
    transform: "translate(76.099 83.697)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 3.775,
    y2: 20.651,
    transform: "translate(76.932 109.275)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M323.564,334.9l5.587-5.747L315.75,317.8l14.431-12.231",
    transform: "translate(-261.277 -202.852)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x1: 2.91,
    y2: 20.2,
    transform: "translate(101.303 108.205)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M446.3,322.752l9.54-9.121L440.48,303.59",
    transform: "translate(-329.209 -201.774)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M448.8,381.3l7.218-17.5L445.21,353.37",
    transform: "translate(-331.785 -228.885)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x1: 28.77,
    y2: 10.833,
    transform: "translate(29.473 170.609)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M196.15,499.4c.1,4.244.975,7.832,2.86,10.41,14.29,19.581,61.343-4.294,83.647-17.122",
    transform: "translate(-196.139 -304.763)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M197.713,481.41c-.414,2.067-.733,4.08-.943,6.006",
    transform: "translate(-196.477 -298.619)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M268.492,309.05s-30.956,9.485-40.237,20.565c-5.323,6.362-16.2,26.639-22.336,45.742",
    transform: "translate(-201.46 -204.747)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    y1: 18.001,
    x2: 7.668,
    transform: "translate(34.892 161.402)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M228.072,555.462,215.95,603.1l71.716,23.743,11.357-44.358V548.95",
    transform: "translate(-206.923 -335.404)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M450.29,310.01s15.5,2.473,26.238,8.8",
    transform: "translate(-334.551 -205.27)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M514.4,436.562c8.761,2.063,19.071-10.05,20.36-20.874.842-7.086,2.618-34.608,3.862-52.008",
    transform: "translate(-369.467 -234.5)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M493.753,371.34c-4.95,17.441-11.138,40.173-11.735,46.735a21.958,21.958,0,0,0,7.3,18.857",
    transform: "translate(-351.776 -238.672)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M469.152,663.47,413.56,681.876,405.4,650",
    transform: "translate(-310.103 -390.438)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 17.946,
    y2: 70.528,
    transform: "translate(157.228 197.167)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y1: 17.186,
    x2: 7.108,
    transform: "translate(169.782 92.695)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M526.222,268.14l1.207-9.413-2.159-10.674a7.957,7.957,0,0,1,4.258-8.7l7.158-3.561",
    transform: "translate(-375.301 -164.848)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M551.138,289.48a11.142,11.142,0,0,1-5.738,6.648",
    transform: "translate(-386.351 -194.089)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M510.671,331.127l-6.831-1.207,3.32-18.82,26.407,4.658",
    transform: "translate(-363.716 -205.864)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M561.317,353.37l-.947,5.382-13.21-2.331",
    transform: "translate(-387.31 -228.885)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M384.406,420.106l6.562-2.386L402.4,449.145l-17.955,6.535-3.957-10.87",
    transform: "translate(-296.536 -263.932)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M355.991,279.277c-5.852,0-11.389-2.623-16.015-7.586a39.051,39.051,0,0,1-9.331-19.841,2.866,2.866,0,0,0-5.647.984c2.655,15.232,11.416,26.767,22.518,30.7",
    transform: "translate(-266.29 -172.301)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M395.974,297.91V284.841c13.688-1.571,25.041-14.29,28.128-32.008a2.866,2.866,0,0,0-5.647-.984,39.05,39.05,0,0,1-9.331,19.841c-4.627,4.964-10.164,7.586-16.015,7.586",
    transform: "translate(-303.409 -172.301)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M329.959,218.747a51.666,51.666,0,0,1-.369-6.166V199.726A8.978,8.978,0,0,1,332.609,193",
    transform: "translate(-268.815 -141.543)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M447.38,191.04a8.993,8.993,0,0,1,4.208,7.618v12.855a51.667,51.667,0,0,1-.369,6.166",
    transform: "translate(-332.967 -140.476)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M460.57,356.132A28.631,28.631,0,0,0,487.1,327.58V310.9A41.528,41.528,0,0,1,498.93,281.87",
    transform: "translate(-340.15 -189.944)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M437.22,411.223l2.933-1.343a3.1,3.1,0,0,1,4.2,1.726h0a3.109,3.109,0,0,1-1.68,3.953",
    transform: "translate(-327.433 -259.507)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M449.65,427.281A2.641,2.641,0,0,0,451.243,424h0a2.642,2.642,0,0,0-3.561-1.626l-1.352.583",
    transform: "translate(-332.395 -266.349)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M454.877,437.84a2.38,2.38,0,0,0,1.539-2.8h0a2.38,2.38,0,0,0-3.147-1.68",
    transform: "translate(-336.174 -272.367)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M422.45,455.556l16.658-7.058a2.513,2.513,0,0,0,1.5-2.719h0A2.515,2.515,0,0,0,437.3,443.8",
    transform: "translate(-319.389 -278.062)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M405.4,409.726l7.063-7.76,9.144-3.151a2.5,2.5,0,0,1,2.978,1.111h0a2.5,2.5,0,0,1-1.025,3.474l-3.67,1.876L413.9,408.6",
    transform: "translate(-310.103 -253.561)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M442.5,595.517l21.111,1.271,17.65-11.658",
    transform: "translate(-330.309 -355.108)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M322.725,587.68l-2.473,9.226-21.116,1.271-7.277-4.8",
    transform: "translate(-248.266 -356.497)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M379.083,527.382l-37.436,13.625L333.96,519.9",
    transform: "translate(-271.195 -319.582)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M315.75,366.738l44.909-16.348,3.374,9.28",
    transform: "translate(-261.277 -227.262)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M299.359,421.693l-10.469-28.77,7.218-2.623",
    transform: "translate(-246.648 -248.998)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    y1: 2.495,
    x2: 6.853,
    transform: "translate(113.453 203.278)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 13.402,
    cy: 13.402,
    r: 13.402,
    transform: "translate(146.27 74.962)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M554.81,232.682a13.4,13.4,0,1,0,7.122,7.117",
    transform: "translate(-389.919 -156.714)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Speech_bubble",
    transform: "translate(176.935 15.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M557.505,438.791H480.34L493.6,425.529V392.972a8.442,8.442,0,0,1,8.442-8.442h55.461a8.442,8.442,0,0,1,8.442,8.442v37.377A8.442,8.442,0,0,1,557.505,438.791Z",
    transform: "translate(-480.34 -384.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M493.6,418.944V392.972a8.442,8.442,0,0,1,8.442-8.442h55.461a8.442,8.442,0,0,1,8.442,8.442v37.377a8.442,8.442,0,0,1-8.442,8.442H480.34L493.6,425.529",
    transform: "translate(-480.34 -384.53)",
    fill: "none",
    stroke: "#3c475d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 4.059,
    cy: 4.059,
    r: 4.059,
    transform: "translate(27.889 23.074)",
    fill: "#3c475d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 4.059,
    cy: 4.059,
    r: 4.059,
    transform: "translate(45.376 23.074)",
    fill: "#3c475d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 4.059,
    cy: 4.059,
    r: 4.059,
    transform: "translate(62.856 23.074)",
    fill: "#3c475d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDoc);
export default __webpack_public_path__ + "static/media/illustration_doc.3c525920da0ac7969398bb13123d523c.svg";
export { ForwardRef as ReactComponent };